module.exports = __webpack_public_path__ + "home_branch_2.png?f58ba12952a89a64e7fb0a903f4f0512";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_branch_2.png
// module id = 51
// module chunks = 0